function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.4375,7.5 L0.5625,7.5 C0.253125,7.5 0,7.246875 0,6.9375 L0,5.25 C0,4.0078125 1.0078125,3 2.25,3 L4.5,3 L4.5,0.5625 C4.5,0.253125 4.753125,0 5.0625,0 L6.9375,0 C7.246875,0 7.5,0.253125 7.5,0.5625 L7.5,3 L13.5,3 L13.5,0.5625 C13.5,0.253125 13.753125,0 14.0625,0 L15.9375,0 C16.246875,0 16.5,0.253125 16.5,0.5625 L16.5,3 L18.75,3 C19.9921875,3 21,4.0078125 21,5.25 L21,6.9375 C21,7.246875 20.746875,7.5 20.4375,7.5 Z M0.5625,9 L20.4375,9 C20.746875,9 21,9.253125 21,9.5625 L21,21.75 C21,22.9921875 19.9921875,24 18.75,24 L2.25,24 C1.0078125,24 0,22.9921875 0,21.75 L0,9.5625 C0,9.253125 0.253125,9 0.5625,9 Z M6,18.5625 C6,18.253125 5.746875,18 5.4375,18 L3.5625,18 C3.253125,18 3,18.253125 3,18.5625 L3,20.4375 C3,20.746875 3.253125,21 3.5625,21 L5.4375,21 C5.746875,21 6,20.746875 6,20.4375 L6,18.5625 Z M6,12.5625 C6,12.253125 5.746875,12 5.4375,12 L3.5625,12 C3.253125,12 3,12.253125 3,12.5625 L3,14.4375 C3,14.746875 3.253125,15 3.5625,15 L5.4375,15 C5.746875,15 6,14.746875 6,14.4375 L6,12.5625 Z M12,18.5625 C12,18.253125 11.746875,18 11.4375,18 L9.5625,18 C9.253125,18 9,18.253125 9,18.5625 L9,20.4375 C9,20.746875 9.253125,21 9.5625,21 L11.4375,21 C11.746875,21 12,20.746875 12,20.4375 L12,18.5625 Z M12,12.5625 C12,12.253125 11.746875,12 11.4375,12 L9.5625,12 C9.253125,12 9,12.253125 9,12.5625 L9,14.4375 C9,14.746875 9.253125,15 9.5625,15 L11.4375,15 C11.746875,15 12,14.746875 12,14.4375 L12,12.5625 Z M18,18.5625 C18,18.253125 17.746875,18 17.4375,18 L15.5625,18 C15.253125,18 15,18.253125 15,18.5625 L15,20.4375 C15,20.746875 15.253125,21 15.5625,21 L17.4375,21 C17.746875,21 18,20.746875 18,20.4375 L18,18.5625 Z M18,12.5625 C18,12.253125 17.746875,12 17.4375,12 L15.5625,12 C15.253125,12 15,12.253125 15,12.5625 L15,14.4375 C15,14.746875 15.253125,15 15.5625,15 L17.4375,15 C17.746875,15 18,14.746875 18,14.4375 L18,12.5625 Z",
  id: "path-2"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layouts",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Solid/calendar-alt",
  transform: "translate(0.500000, 0.771757)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color",
  mask: "url(#mask-2)",
  fill: "#242A42"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.500000, 0.000000)",
  id: "Black"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

function SvgCalendarAlt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "25px",
    viewBox: "0 0 22 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solid/calendar-alt@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt2);
export default __webpack_public_path__ + "static/media/calendar-alt-2.3f4f459c.svg";
export { ForwardRef as ReactComponent };